import { WrapperVariablesDefinition } from '../../../../generic/utils';

import { VariableTypes } from './interfaces';

const variables: WrapperVariablesDefinition<VariableTypes> = {};

export const stateVariables = variables;
